import React, { useCallback, useState, useContext } from "react";
import { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import apiClient from "../libraries/ApiClient";
import { AuthContext } from "../contexts/AuthContext";
import axios from "axios";
import { useQueryClient } from "react-query";
import LoadingModal from "./Modal/LoadingModal";

function UploadExcel({ setExcelFile, disabled, buttonText, year, month }) {
  const queryClient = useQueryClient();
  const { myAuth } = useContext(AuthContext);
  const apiUrl = import.meta.env.VITE_API_ROOT_URL;

  const AccountRowId = myAuth?.AccountRowId;
  const Token = myAuth?.Token;
  //console.log(AccountRowId,Token);
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  //console.log(year, month);
  const sendEcxelData = async () => {
    setOpen(true);
    const exselFd = new FormData();
    exselFd.append("ByFiles", file[0]);
    exselFd.append("AccountRowId", AccountRowId);
    exselFd.append("Month", month);
    exselFd.append("Year", year);
    const fileName = file[0].name;
    apiClient.logOfActionWithoutId("UplUploadExceload", "Before", {
      fileName,
      AccountRowId,
      month,
      year,
    });

    try {
      const res = await axios.post(`${apiUrl}api/shift/Upload`, exselFd, {
        headers: {
          Authorization: `${Token}`,
        },
      });
      apiClient.logOfActionWithoutId("UplUploadExceload", "Completed", {
        fileName,
        AccountRowId,
        month,
        year,
      });
      if (+res.data.Code === 0) {
        queryClient.invalidateQueries("sendDateData");
        setOpen(false);
      }
      if (+res.data.Code !== 0) {
        alert("excel檔案上傳失敗");
        setOpen(false);
      }
    } catch (e) {
      if (e.response?.status !== 200) {
        alert("excel檔案上傳失敗");
        setOpen(false);
      }
    }
  };

  useEffect(() => {
    //console.log(year, month);
    //console.log(file);
    if (file) {
      sendEcxelData();
    }
  }, [file]);

  const onDrop = useCallback((file) => {
    setFile(file);
    const fileName = file[0].name;
    apiClient.logOfActionWithoutId("UploadExcel", "onDrop", {
      fileName,
    });
  }, []);
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    disabled: disabled,
    multiple: false,
  });

  return (
    <section
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        boxSizing: "border-box",
        cursor: "pointer",
        vertical: "middle",
        minWidth: "64px",
        padding: "8px 16px 8px 16px",
        backgroundColor: "#057AFF",
        color: "#ffffff",
        borderRadius: "4px",
        boxShadow: "none",
        fontSize: 14,
        borderColor: "#057AFF",
        "&:hover": {
          backgroundColor: "#1570EF",
          cursor: "pointer",
          boxShadow: "none",
          borderColor: "#057AFF",
        },
      }}
    >
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        <p size="small" variant="contained">
          {buttonText}
        </p>
      </div>
      <LoadingModal isOpen={open} />
    </section>
  );
}
export default UploadExcel;
